export const ingredientTypeMap = {
  CUSTOM_INGREDIENTS: 'CI',
  SYSCO_PRODUCTS: 'SP',
  BATCH_RECIPES: 'BR',
};
